<template>
    <svg viewBox="0 0 32 32" version="1.1" aria-hidden="false" fill="currentColor">
        <path d="M10 9V0h12v9H10zm12 5h10v18H0V14h10v9h12v-9z"></path>
    </svg>
</template>
